// @flow
import type { GlobalState } from "../../lib/types";

export const getZip = (state: GlobalState) => {
  return state.userData.zip;
};
